import axios from "axios";
import * as React from "react";
import { AuthInterceptor } from "../middleware/AuthInteceptor";
import { createContext } from "react";
import ServiceApi from "../models/ServiceApi.model";
import ConfigService from '../config/config.service';

export const ServiceContext = createContext<ServiceApi>(null);
export const ServiceProvider: React.SFC = props => {
  const restClient = axios.create({
    baseURL: ConfigService.getConfig().apiUrl
  });
  restClient.interceptors.request.use(AuthInterceptor);
  const apis = new ServiceApi(restClient);
  return <ServiceContext.Provider value={apis}>{props.children}</ServiceContext.Provider>;
};



// WEBPACK FOOTER //
// ./src/services/provider/Service.provider.tsx